export interface MachineOptionLike {
  name?: string | null;
  serialNumber?: string | null;
  venue?: { name?: string | null } | null;
  /** Flat venue name when the API does not nest under `venue`. */
  venueName?: string | null;
}

/** Primary machine identifier: configured name, then serial, then fallback. */
export function machineDisplayName(
  machine: Pick<MachineOptionLike, 'name' | 'serialNumber'>
): string {
  return machine.name?.trim() || machine.serialNumber?.trim() || 'Unnamed machine';
}

export function machineVenueName(machine: MachineOptionLike): string | null {
  const nested = machine.venue?.name?.trim();
  if (nested) return nested;
  const flat = machine.venueName?.trim();
  return flat || null;
}

/**
 * Dropdown / select label: venue first (where the machine lives), then name or serial.
 * Serial is appended only when it is not already part of the display name.
 */
export function machineOptionLabel(machine: MachineOptionLike): string {
  const displayName = machineDisplayName(machine);
  const venue = machineVenueName(machine);
  const serial = machine.serialNumber?.trim();

  let label = venue ? `${venue} · ${displayName}` : displayName;

  if (serial && serial !== displayName && !displayName.includes(serial)) {
    label += ` (${serial})`;
  }

  return label;
}
